import { Container } from "@mui/material";
import Page from "../components/Page";

export default function InboundTraffic({ children }) {
    return (
        <Page title="Inbound Traffic | HCC">
            <Container maxWidth="xl">{children}</Container>
        </Page>
    );
}
